export abstract class ApiResponse<T = unknown, E = Error> {
    abstract handle(callbacks: {
        onLoading: () => void,
        onSuccess: (data: T, timestamp: Date) => void,
        onFailure: (error: E, message: string, timestamp: Date) => void
    }): void;
}

export class Loading extends ApiResponse<never> {
    handle(callbacks: { onLoading: () => void, onSuccess: unknown, onFailure: unknown }) {
        callbacks.onLoading();
    }
}

export class Success<T> extends ApiResponse<T> {
    constructor(public data: T, public timestamp: Date) { super(); }

    handle(callbacks: { onLoading: unknown, onSuccess: (data: T, ts: Date) => void, onFailure: unknown }) {
        callbacks.onSuccess(this.data, this.timestamp);
    }
}

export class Failure extends ApiResponse<never> {
    constructor(public error: Error, public message: string, public timestamp: Date) { super(); }

    handle(callbacks: { onLoading: unknown, onSuccess: unknown, onFailure: (error: Error, msg: string, ts: Date) => void }) {
        callbacks.onFailure(this.error, this.message, this.timestamp);
    }
}

export interface ApiResponseBody<T> {
    message: string;
    data: T;
    timestamp: Date;
}

export class NetworkError {
    message: string;
    timestamp: Date;
    code: number;
    path: string;
    original?: any;

    constructor(message: string, timestamp: Date, code: number, path: string, original?: any) {
        this.message = message;
        this.timestamp = timestamp;
        this.code = code;
        this.path = path;
        this.original = original;
    }
}